import React, { memo, useMemo } from 'react'
import styled from 'styled-components'
import { getPaletteColor } from 'pcln-design-system'
import { ArrowLeft, ArrowRight } from 'pcln-icons'
import { getNextMonthLabel, getPrevMonthLabel } from '../utils/ariaLabelGenerators'

const LeftArrow = styled.button`
  display: none;
  ${(props) => props.theme.mediaQueries[1]} {
    display: block;
  }
  background-color: ${getPaletteColor('background.lightest')};
  padding: ${(props) => props.theme.space[1]} ${(props) => props.theme.space[3]};
  margin: 10px 0;
  position: absolute;
  top: 0;
  left: 0;
  border: 0;
  ${(props: IArrowProps) => props.roundedCorners && 'margin-left: 6px;'}
  cursor: pointer;
`

const RightArrow = styled(LeftArrow)`
  ${(props: IArrowProps) => props.roundedCorners && 'margin-right: 6px;'}
  left: auto;
  right: 0;
  background-color: ${getPaletteColor('background.lightest')};
`

export interface IArrowProps {
  isPrev?: boolean
  monthCount?: number
  monthsToShow?: number
  roundedCorners?: boolean
  onClick?: (evt) => void
  onFocus?: (evt) => void
}

function Arrow({ isPrev, monthCount = 0, monthsToShow = 1, ...props }: IArrowProps) {
  const ariaLabel = useMemo(() => {
    const label = isPrev ? getPrevMonthLabel(monthCount) : getNextMonthLabel(monthCount, monthsToShow)
    return `Show ${label}`
  }, [isPrev, monthCount, monthsToShow])

  return isPrev ? (
    <LeftArrow aria-label={ariaLabel} {...props}>
      <ArrowLeft />
    </LeftArrow>
  ) : (
    <RightArrow aria-label={ariaLabel} {...props}>
      <ArrowRight />
    </RightArrow>
  )
}

export default memo(Arrow)
